<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { OrderPaymentStatus } from "@/constants/order";

const { t } = useI18n();

const props = defineProps<{
  status: OrderPaymentStatus;
}>();

const classes = computed<string>(() => {
  switch (props.status) {
    case OrderPaymentStatus.rated:
      return "bg-amber-lighten-2 text-grey-darken-3";
    case OrderPaymentStatus.locked:
      return "bg-indigo-lighten-1 text-white";
    case OrderPaymentStatus.inherited:
      return "bg-grey-lighten-4 text-grey-darken-3 order-payment-status--bordered";
    case OrderPaymentStatus.synced:
      return "bg-blue-grey-darken-1 text-white";
    case OrderPaymentStatus.created:
    default:
      return "bg-grey-lighten-4 text-grey-darken-3";
  }
});

const isLocked = computed<boolean>(() => {
  return props.status === OrderPaymentStatus.locked;
});

const label = computed<string>(() => {
  return t(`order-payments.status-${props.status}`);
});
</script>

<template>
  <span :class="[classes, { 'order-payment-status--locked': isLocked }]" class="order-payment-status">
    <v-icon v-if="isLocked" size="14">mdi-lock-outline</v-icon>
    {{ label }}
  </span>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.order-payment-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  &--locked {
    padding-left: 6px;
  }

  &--bordered {
    border: 1px solid $grey-light;
  }
}
</style>
